import { useQuery } from "@tanstack/react-query";
import { recomendacaoPublica } from "~/server/tracking";
import ProductShelf from "~/components/product/ProductShelf";

/**
 * Consome o proxy de recomendação pública (funciona mesmo sem identidade
 * resolvida -- só por visitor_id). ProductShelf já devolve `null` quando
 * `products` está vazio/nulo, então o fallback "não renderiza a seção" é
 * automático -- nunca um erro visível nem loading infinito (retry: false
 * evita re-tentar contra um CRM fora do ar).
 */
function PersonalizedShelf() {
  const { data } = useQuery({
    queryKey: ["recomendacao-publica"],
    queryFn: () => recomendacaoPublica(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  if (!data || data.produtos.length === 0) return null;

  return <ProductShelf products={data.produtos} title="Recomendado para você" />;
}

export default PersonalizedShelf;
